import Palette from '@/styles/Themes/Palette';
import { cssVars } from '@/styles/Themes/cssVars';
import styled, { css } from 'styled-components';

export const StyledLabel = styled.label`
    display: flex;
    max-width: max-content;
    cursor: pointer;
    align-items: flex-start;
    gap: 8px;

    @media (min-width: 768px) {
        gap: 15px;
    }

    @media (min-width: 1024px) {
        align-items: center;
    }
`;

export const HiddenInput = styled.input`
    display: none;
`;

export const CircleIndicator = styled.div<{ $checked: boolean }>`
    margin: 0 2px;
    display: flex;
    height: 22px;
    width: 22px;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    ${({ $checked }) =>
        $checked
            ? css`
                  border: 2px solid ${Palette.green.normal};

                  &::after {
                      content: '';
                      height: 12px;
                      width: 12px;
                      border-radius: 50%;
                      background: ${Palette.gradient.light};
                  }
              `
            : css`
                  border: 1px solid ${Palette.gray.gray3};
              `}
`;

export const SquareIndicator = styled.div<{ $checked: boolean; $disabled: boolean }>`
    position: relative;
    margin: 0 2px;
    display: flex;
    height: 22px;
    width: 22px;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: 8px;

    ${({ $checked }) =>
        $checked
            ? css`
                  background: ${Palette.gradient.light};
              `
            : css`
                  border: 1px solid ${Palette.gray.gray3};

                  &:hover {
                      border-color: ${Palette.green.normal};
                  }
              `}

    ${({ $disabled }) =>
        $disabled &&
        css`
            cursor: not-allowed;
            background: ${Palette.gradient.gray};
        `}
`;

export const Checkmark = styled.div`
    position: absolute;
    bottom: 8px;
    height: 8px;
    width: 12px;
    transform: rotate(-45deg);
    border-bottom: 2px solid ${Palette.white.normal};
    border-left: 2px solid ${Palette.white.normal};
`;

export const LabelText = styled.div<{ $required: boolean }>`
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: ${cssVars.fg_grayDarker_white};

    ${({ $required }) =>
        $required &&
        css`
            &::after {
                content: '*';
                margin-left: 4px;
                color: ${Palette.state.error};
            }
        `}
`;
